import { render, staticRenderFns } from "./ReviewDingpanAuction.vue?vue&type=template&id=4a360b2f&scoped=true"
import script from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
export * from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
import style0 from "./ReviewDingpanAuction.vue?vue&type=style&index=0&id=4a360b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a360b2f",
  null
  
)

export default component.exports